module.exports = __webpack_public_path__ + "img/device_loc.2fffcce0.png";